import { MosqueIcon } from './MosqueIcon';

/**
 * author: Google
 * id 55847C89-2AE5-4F91-85AA-761FD8CE57F0
 * name mosque
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mosque.svg
 * tags
 * - Religion 
 */
export const IslamIcon = MosqueIcon;
export default IslamIcon